module.exports = __webpack_public_path__ + "img/07.3757256d.png";